/** @format */

import React from 'react';

export const RouterContextDefault = {
    location: undefined,
    navigate: undefined,
    params: undefined
};

export const RouterContext = React.createContext(RouterContextDefault);
